<script lang="ts" setup>
  import {useI18n} from 'vue-i18n';
  import {ref} from 'vue';
  import useCpBem from '~/composables/useCpBem';
  import CpText from '~/components/cp/CpText/CpText.vue';
  import CpAvatar from '~/components/cp/CpAvatar/CpAvatar.vue';
  import CpButtonIcon from '~/components/cp/CpButtonIcon/CpButtonIcon.vue';
  import CpPillPdp from '~/components/cp/CpPill/CpPillPdp/CpPillPdp.vue';

  const props = withDefaults(
    defineProps<{
      kind: 'pdp'|'account'|'nonAnswered'
      image: string
      question: string
      userName: string
      questionDate: string
      quantity?: string
    }>(), {
        quantity: undefined,
    },
  );
  const emit = defineEmits([
    'actionsClick', 'accountClick',
  ]);
  const active = ref(false);

  function emitter() {
    if (props.kind === 'account') {
      active.value = !active.value;
      emit('accountClick', active.value);
    } else {
      emit('actionsClick');
    }
  }

  const {b, e, em} = useCpBem('cp-card-header');
  const {t} = useI18n();
</script>
<template>
    <div :class="b" data-testid="card-header">
        <div :class="e('main-container')">
            <CpAvatar :class="e('avatar')" size="small" :image="image" :alt="userName" />
            <div :class="e`vertical-container`">
                <CpText variant="heading-h3-fake">
                    {{ question }}
                </CpText>
                <div :class="em(`small-text-container`, {noAnswered: kind==='nonAnswered'})">
                    <CpText variant="caption-bold">
                        {{ userName + ', ' }}
                    </CpText>
                    <CpText variant="caption-bold" type="neutral">
                        {{ questionDate }}
                    </CpText>
                </div>
                <CpPillPdp
                    v-if="kind==='pdp'"
                    kind="reviews"
                    border="borderPrimary"
                    label-kind="primary"
                    variant="white"
                    :label="t('answers', {count: quantity})"
                />
            </div>
        </div>
        <CpButtonIcon
            v-if="kind!=='nonAnswered'"
            :kind="kind==='pdp' ? 'actions' : 'accordion'"
            @click="emitter"
        />
    </div>
</template>
<style scoped lang="scss">
  @import "assets/style/global.scss";
  .cp-card-header {
    padding: $cp-gutter;
    border-bottom: $cp-border-standard;
    display: flex;
    justify-content: space-between;
    gap: $cp-gutter;
    &__main-container {
      display: flex;
      gap: $cp-gutter;
    }
    &__vertical-container {
      display: flex;
      flex-direction: column;
      gap: $cp-gutter-small;
      min-width: 208px;
      &--no-answered {
        min-width: 248px;
      }
    }
    &__small-text-container {
      line-height: 0;
    }
    &__avatar {
      min-height: 32px;
      min-width: 32px;
    }
  }
</style>
<i18n locale="es-US" lang="yaml">
  answers: '{count} respuesta | {count} respuestas'
</i18n>
